import { Injectable } from '@angular/core';
import { ElementInterface } from '../shared/drag-drop-content/interfaces/element.interface';

@Injectable({
  providedIn: 'root'
})
export class FormBuilderStateService {
  private _addedComponents: Array<ElementInterface> = [];
  private _selectedComponent: ElementInterface | null = null;
  private _activeTab: number = 2;
  private _hasPersistedContent: boolean = false;

  get addedComponents(): Array<ElementInterface> {
    return this._addedComponents;
  }

  set addedComponents(components: Array<ElementInterface>) {
    this._addedComponents = components;
  }

  get selectedComponent(): ElementInterface | null {
    return this._selectedComponent;
  }

  set selectedComponent(component: ElementInterface | null) {
    this._selectedComponent = component;
  }

  get activeTab(): number {
    return this._activeTab;
  }

  set activeTab(tab: number) {
    this._activeTab = tab;
  }

  get hasPersistedContent(): boolean {
    return this._hasPersistedContent;
  }

  set hasPersistedContent(value: boolean) {
    this._hasPersistedContent = value;
  }

  clearState() {
    this._addedComponents = [];
    this._selectedComponent = null;
    this._activeTab = 2;
    this._hasPersistedContent = false;
  }
}